module.exports = __webpack_public_path__ + "img/i_house_score.86089d01.svg";